/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_By_RelevanceInputs */

const en_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by relevance`)
};

const zh_hans1_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按相关度`)
};

const pt_br2_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por relevância`)
};

const es_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por relevancia`)
};

const fr_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par pertinence`)
};

const de_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nach Relevanz`)
};

const ru_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`по релевантности`)
};

const it_search_by_relevance = /** @type {(inputs: Search_By_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per rilevanza`)
};

/**
* | output |
* | --- |
* | "by relevance" |
*
* @param {Search_By_RelevanceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_by_relevance = /** @type {((inputs?: Search_By_RelevanceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_By_RelevanceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_by_relevance(inputs)
	if (locale === "pt-BR") return pt_br2_search_by_relevance(inputs)
	if (locale === "es") return es_search_by_relevance(inputs)
	if (locale === "fr") return fr_search_by_relevance(inputs)
	if (locale === "de") return de_search_by_relevance(inputs)
	if (locale === "ru") return ru_search_by_relevance(inputs)
	if (locale === "it") return it_search_by_relevance(inputs)
	return en_search_by_relevance(inputs)
});